import React, { useEffect } from 'react'

import { WrappedFieldProps } from 'redux-form'

import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'

import useInput from '~/hooks/useInput'

const SearchField = ({ input, meta: _meta, ...props }: WrappedFieldProps) => {
  const { bind, reset, setValue, value } = useInput(input.value || null)

  useEffect(() => {
    setValue(input.value)
  }, [input.value])

  useEffect(() => {
    if (!value && !!input.value) {
      input.onChange(null)
    }
  }, [value])

  return (
    <TextField
      fullWidth
      variant="outlined"
      {...props}
      {...bind}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.code === 'Enter') {
          event.preventDefault()
          event.stopPropagation()

          input.onChange(value)
        }
      }}
      InputProps={{
        endAdornment: (
          <>
            {!!value && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  edge="end"
                  onClick={() => {
                    reset()
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            )}
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                onClick={() => {
                  input.onChange(value)
                }}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          </>
        )
      }}
    />
  )
}

export default SearchField
